import { useMemo } from 'react';
import { useUtils } from '../../../../context/UtilsContext';

/** Event type for workout plan assignment / profile APIs. */
export function useWorkoutPlanEventTypeId() {
  const { sessionUtils } = useUtils();
  return useMemo(
    () =>
      sessionUtils?.event_types?.[0]?.event_types?.find(
        (x) => x.description === 'modify_user_profile'
      )?.id,
    [sessionUtils]
  );
}
